import PropertyType from '../Modifiers/PropertyType.js';

var BlockBorderWidthOptions = /*#__PURE__*/function (BlockBorderWidthOptions) {
  BlockBorderWidthOptions["none"] = "border-width: 0;";
  BlockBorderWidthOptions["thin"] = "border-width: 0.05rem;";
  BlockBorderWidthOptions["regular"] = "border-width: 0.15rem;";
  BlockBorderWidthOptions["medium"] = "border-width: 0.25rem;";
  BlockBorderWidthOptions["heavy"] = "border-width: 0.5rem;";
  return BlockBorderWidthOptions;
}(BlockBorderWidthOptions || {}); // we need these because we can't use `heavy` as a css variable value
var BlockBorderWidthValues = /*#__PURE__*/function (BlockBorderWidthValues) {
  BlockBorderWidthValues["none"] = "0";
  BlockBorderWidthValues["thin"] = "0.05rem";
  BlockBorderWidthValues["regular"] = "0.15rem";
  BlockBorderWidthValues["medium"] = "0.25rem";
  BlockBorderWidthValues["heavy"] = "0.5rem";
  return BlockBorderWidthValues;
}(BlockBorderWidthValues || {});
var ThemeBlockBorderWidth = new PropertyType({
  name: 'BlockBorderWidth',
  propertyFromApi: 'block-border-width',
  convertValueToCssPropertiesFunction: function convertValueToCssPropertiesFunction(value) {
    return BlockBorderWidthOptions[value];
  },
  options: BlockBorderWidthOptions,
  defaultValue: 'none',
  selector: '.block',
  cssVariable: '--block-border-width',
  cssVariableFunction: function cssVariableFunction(value) {
    return BlockBorderWidthValues[value];
  }
}, 'theme');
var FormBlockBorderWidth = new PropertyType({
  name: 'BlockBorderWidth',
  propertyFromApi: 'block-border-width',
  convertValueToCssPropertiesFunction: function convertValueToCssPropertiesFunction(value) {
    return BlockBorderWidthOptions[value];
  },
  options: BlockBorderWidthOptions,
  defaultValue: 'none',
  selector: '.block',
  cssVariable: '--block-border-width',
  cssVariableFunction: function cssVariableFunction(value) {
    return BlockBorderWidthValues[value];
  }
}, 'form');

export { FormBlockBorderWidth, ThemeBlockBorderWidth };
//# sourceMappingURL=BlockBorderWidth.js.map
